import React from "react";
import { TextField } from "@mui/material";
import TextFieldForObjectState from "./TextFields/TextFieldForObjectState";
import SelectFieldForObjectState from "./TextFields/SelectFieldForObjectState";
import PhoneNumberFieldForObjectState from "./TextFields/PhoneNumberFieldForObjectState";
import DateFieldForObjectState from "./TextFields/DateFieldForObjectState";
import SeveritySelectFieldForObjectState from "./TextFields/SeveritySelectFieldForObjectState";
import MultiSelectFieldForObjectState from "./TextFields/MultiSelectFieldForObjectState";
import MedicationFieldForObjectState from "./TextFields/MedicationFieldForObjectState";
import PrescriptionMedicationFieldForObjectState from "./TextFields/PrescriptionMedicationFieldForObjectState";
import NonFoodAllergiesFieldForState from "./TextFields/NonFoodAllergiesFieldForState";
import NonFoodAllergiesOtherFieldForState from "./TextFields/NonFoodAllergiesOtherFieldForState";
import NumberFieldForObjectState from "./TextFields/NumberFieldForObjectState";
import TimeFieldForObjectState from "./TextFields/TimeFieldForObjectState";

const DisplayTextField = ({
  formInfo,
  handleChange,
  Object,
  handleNumberChange,
}) => {
  let onlyAppearIfValueIs = Object.onlyAppearIfValueIs;
  let onlyAppearIfValueIsNot = Object.onlyAppearIfValueIsNot;
  let withRegardsTo = Object.withRegardsTo;

  const shouldRenderTextField =
    (onlyAppearIfValueIs === true && formInfo[withRegardsTo]) ||
    (Array.isArray(onlyAppearIfValueIs) &&
      onlyAppearIfValueIs.includes(formInfo[withRegardsTo])) ||
    (onlyAppearIfValueIsNot === true &&
      (!formInfo[withRegardsTo] || formInfo[withRegardsTo] === "")) ||
    (Array.isArray(onlyAppearIfValueIsNot) &&
      formInfo[withRegardsTo] &&
      !onlyAppearIfValueIsNot.includes(formInfo[withRegardsTo])) ||
    (onlyAppearIfValueIs === false && onlyAppearIfValueIsNot === false);

  if (!shouldRenderTextField) {
    return null;
  } else {
    if (Object.TextField === "TextFieldForObjectState") {
      return (
        <TextFieldForObjectState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "SelectFieldForObjectState") {
      return (
        <SelectFieldForObjectState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "SeveritySelectFieldForObjectState") {
      return (
        <SeveritySelectFieldForObjectState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "MultiSelectFieldForObjectState") {
      return (
        <MultiSelectFieldForObjectState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "DateFieldForObjectState") {
      return (
        <DateFieldForObjectState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "NumberFieldForObjectState") {
      return (
        <NumberFieldForObjectState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "PhoneNumberFieldForObjectState") {
      return (
        <>
          <PhoneNumberFieldForObjectState
            formInfo={formInfo}
            Object={Object}
            handleChange={handleChange}
          />
        </>
      );
    }

    if (Object.TextField === "MedicationFieldForObjectState") {
      return (
        <MedicationFieldForObjectState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "PrescriptionMedicationFieldForObjectState") {
      return (
        <PrescriptionMedicationFieldForObjectState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "NonFoodAllergiesFieldForState") {
      return (
        <NonFoodAllergiesFieldForState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "NonFoodAllergiesOtherFieldForState") {
      return (
        <NonFoodAllergiesOtherFieldForState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
    if (Object.TextField === "TimeFieldForObjectState") {
      return (
        <TimeFieldForObjectState
          formInfo={formInfo}
          Object={Object}
          handleChange={handleChange}
        />
      );
    }
  }

  return null;
};

export default DisplayTextField;
